import { Outlet } from 'react-router-dom'
import Navigation from './Navigation'
import AudioPlayer from '../audio/AudioPlayer'
import { useAudioPlayer } from '../../hooks/useAudioPlayer'
import './Layout.css'

export default function Layout() {
  const { currentSong } = useAudioPlayer()

  return (
    <div className={`layout ${currentSong ? 'has-player' : ''}`}>
      <Navigation />
      <main className="layout-main">
        <Outlet />
      </main>
      <AudioPlayer />
    </div>
  )
}
